import React, { useState } from "react";
import {
  StyleSheet,
  TouchableOpacity,
  TouchableWithoutFeedback,
} from "react-native";
import { View, Text } from "../Themed";
import Animated, {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
  Easing,
} from "react-native-reanimated";
import { Feather } from "@expo/vector-icons";
import Colors from "../../constants/Colors";
import useThemeColor from "../../hooks/useThemeColor";

type Props = {
  headerSection: any;
  bodySection: any;
  note?: string | null | undefined;
};

export default function Accordion(props: Props) {
  const { headerSection, bodySection, note } = props;

  const shareValue = useSharedValue(0);
  const [bodySectionHeight, setBodySectionHeight] = useState(0);

  const bodyHeight = useAnimatedStyle(() => ({
    height: interpolate(shareValue.value, [0, 1], [0, bodySectionHeight]),
  }));

  const iconStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          rotate: `${interpolate(shareValue.value, [0, 1], [0, 180])}deg`,
        },
      ],
    };
  });

  const toggleButton = () => {
    if (shareValue.value === 0) {
      shareValue.value = withTiming(1, {
        duration: 500,
        easing: Easing.bezier(0.4, 0.0, 0.2, 1),
      });
    } else {
      shareValue.value = withTiming(0, {
        duration: 500,
        easing: Easing.bezier(0.4, 0.0, 0.2, 1),
      });
    }
  };

  return (
    <View style={{ borderTopColor: Colors.tinted_grey_300, borderTopWidth: 1 }}>
      <TouchableOpacity
        style={{ flexDirection: "row" }}
        activeOpacity={0.7}
        onPress={toggleButton}
      >
        {headerSection}
        <View
          style={[
            {
              height: 16,
              alignSelf: "center",
              marginLeft: -15,
              flexDirection: "row",
              alignContent: "center",
              justifyContent: "center",
              alignItems: "center",
            },
          ]}
        >
          {note ? (
            <Text
              lightColor={Colors.nuetral_grey_600}
              darkColor={Colors.nuetral_grey_600}
              style={{
                marginRight: 8,
                fontStyle: "italic",
              }}
            >
              Note Added
            </Text>
          ) : null}
          <Animated.View style={iconStyle}>
            <Feather
              name={"chevron-down"}
              size={16}
              color={useThemeColor(
                {
                  light: Colors.nuetral_grey_700,
                  dark: Colors.base_colors_white,
                },
                "background"
              )}
            />
          </Animated.View>
        </View>
      </TouchableOpacity>
      <Animated.View style={[{ overflow: "hidden" }, bodyHeight]}>
        <View
          style={styles.bodyContainer}
          onLayout={(event) => {
            setBodySectionHeight(event.nativeEvent.layout.height);
          }}
        >
          {bodySection}
        </View>
      </Animated.View>
    </View>
  );
}

const styles = StyleSheet.create({
  bodyContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
  },
});
